// extracted by mini-css-extract-plugin
export default {"targetItems":"pSNbuUiKUaEjzmXlZzWQ","blank":"cO6rGsg_MGzQ6csIQMv9","icon":"m0wp5aAclkC2vSermID5"};